import request from './adminRequest'

export const interviewApi = {
  listUser (params) {
    return request.get('/listUser', { params: params })
  },
  getUser (uid) {
    return request.get('/user/' + uid)
  },
  listInterview (params) {
    return request.get('/listInterview', { params: params })
  },
  getInterview (roomId) {
    return request.get('/interview/' + roomId)
  },
  listUserPreference (params) {
    return request.get('/listUserPreference', { params: params })
  },
  updateQuota (params) {
    return request.post('/updateQuota', params)
  },

}

export default interviewApi
